// extracted by mini-css-extract-plugin
module.exports = {"button":"giftAmountForm_button__G88q8"};